/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import { AuthInternalError, TransportMiddlewareProps } from '../../../../core';

import type { TransportMiddlewareContext, TransportMiddlewareRequest, TransportMiddlewareResponse, NextFunction } from '../../../../core';

export const handleInternalErrorMiddleware = <T, R>(
    next: NextFunction<TransportMiddlewareResponse<R, Error>>,
    ctx: TransportMiddlewareContext,
    req: TransportMiddlewareRequest<T>,
    res: TransportMiddlewareResponse<R, Error>,
) => {
    const { commands } = ctx;
    const errFromRes = res[TransportMiddlewareProps.ErrorResponse];

    if (errFromRes && errFromRes instanceof Error) {
        if (errFromRes instanceof AuthInternalError) {
            commands.showAuthError();
        }
        next(res);
    } else {
        next();
    }
};
